/**
 * ConfigPage.js
 * ==============
 * Full-screen configuration page, reachable from LandingPage via the
 * "Adjust Settings" button. Houses the ConfigPanel and a back button
 * to return to LandingPage.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConfigPanel from './ConfigPanel';
import './ConfigPage.css';

export default function ConfigPage() {
  const navigate = useNavigate();

  return (
    <div className="cfgp-root">
      <div className="cfgp-container">

        {/* ── Header ──────────────────────────────────────────────── */}
        <div className="cfgp-header">
          <button
            className="cfgp-back"
            onClick={() => navigate('/landing')}
            aria-label="Back to home"
          >
            ← Back
          </button>
          <span className="cfgp-title">Settings</span>
        </div>

        {/* ── Config panel ────────────────────────────────────────── */}
        <ConfigPanel />

      </div>
    </div>
  );
}
